/*
 * $Id:: globalsSlice.js 2021/01/11 10:04 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { createSlice } from '@reduxjs/toolkit';

import { getLocale, setLocale } from '../providers';
import { GLOBALS_SLICE_NAME as SLICE_NAME } from './constants';

export const slice = createSlice({
    name: SLICE_NAME,
    initialState: {
        globals: false,
        filtersOptions: {
            trademarks: [],
            designs: [],
            eServices: [],
            patents: [],
            impersonation: [],
            drafts: [],
        },
        countries: null,
        states: null,
        language: getLocale(),
        loading: false,
        globalLoading: false,
        error: false,
    },
    reducers: {
        globals: (state, action) => {
            const { design, eservice, trademark, locarno, patents, impersonation, drafts, ...rest } = action.payload;
            state.globals = rest;
            state.filtersOptions = {
                design: { ...design, locarno },
                eservice: eservice,
                trademark,
                patents,
                impersonation,
                drafts: {
                    trademark: { ...drafts.trademark },
                    design: { ...drafts.design, locarno: { ...drafts.locarno } },
                    patents: { ...drafts.patents },
                },
            };
        },
        setCountries: (state, action) => {
            state.countries = action.payload;
        },
        setStates: (state, action) => {
            state.states = action.payload;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
            setLocale(action.payload);
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
        globalLoading: (state, action) => {
            state.globalLoading = action.payload;
        },
        error: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const globals = (state) => state[SLICE_NAME];
export const countries = (state) => state[SLICE_NAME].countries;
export const states = (state) => state[SLICE_NAME].states;
export const loading = (state) => state[SLICE_NAME].loading;
export const globalLoading = (state) => state[SLICE_NAME].globalLoading;
export const error = (state) => state[SLICE_NAME].error;
export default slice.reducer;
